module.exports = __webpack_public_path__ + "img/img_1.5e96ba62.png";